module.exports = __webpack_public_path__ + "img/空白（纯页码居右）.fde78d56.jpg";